export default "__VITE_ASSET__C6IVP5xv__"